import { Head } from '@/src/views/parts/commons/Head'
import { RequiredAuthProvider } from '@/src/views/providers/RequiredAuthProvider'
import { ArcadeMachinesManagerPage } from '../../../views/pages/ArcadeMachinesManagerPage'

const Page = () => (
  <>
    <Head title="Craft" />
    <RequiredAuthProvider>
      <ArcadeMachinesManagerPage activeTab="Craft" />
    </RequiredAuthProvider>
  </>
)

export default Page
